import { Entity } from '@backstage/catalog-model';

export function isUpdateCheckAvailableForType(entity: Entity): boolean {
  return entity.spec?.type !== 'documentation';
}
